import { useState, useEffect } from 'react';
import { multiversxUrlApi } from 'src/config';
import { handleUnexpectedException } from 'src/helpers/functions';

function useNextRewardCountdown() {
    const [timeRemaining, setTimeRemaining] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRewardData = async () => {
            try {
                const response = await fetch(`${multiversxUrlApi}/stats`);
                const data = await response.json();

                if (response.ok) {
                    const roundsRemaining = data.roundsPerEpoch - data.roundsPassed;
                    const timeInSeconds = roundsRemaining * 6; 
                    setTimeRemaining(timeInSeconds);
                } else {
                    handleUnexpectedException(data.message);
                    setError(`Error: ${data.message}`);
                }
            } catch (error) {
                handleUnexpectedException(error);
                setError(`Error: ${error.message}`);
            } finally {
                setLoading(false);
            }
        };

        fetchRewardData();
    }, []);

    return { timeRemaining, loading, error };
}

export default useNextRewardCountdown;
